// REACT IMPORTS
import React from "react";

// COMPONENT IMPORTS
import SidePanel from "components/auth/SidePanel";
import QuestionsFooter from "components/auth/QuestionsFooter";
import SignUpEmailAttachedForm from "components/auth/SignUpEmailAttachedForm";
import Helment from "components/layout/helmet";
import { TestIdScope } from "utils/testid";

/* ------------------------------------- SIGN UP WITH EMAIL ATTACHED PAGE ------------------------------------- */

const SignUpEmailAttached = () => {
  return (
    <>
      <Helment />

      <TestIdScope scope="auth-sign-up-email-attached">
        <div
          data-testid="auth-sign-up-email-attached-page"
          className="lg:overflow-y-none overflow-y-auto portal-shell h-[var(--shell-vh)] flex flex-col lg:flex-row lg:justify-center relative animate__animated animate__fadeIn"
        >
          <div className="lg:w-2/5 w-full">
            <SidePanel />
          </div>
          <div className="lg:w-3/5 h-full flex flex-col justify-between items-center lg:overflow-y-auto px-4 lg:px-0">
            <div className="lg:pt-[134px] pt-4">
              <SignUpEmailAttachedForm />
            </div>
            <div className={`pb-5 lg:pt-0 pt-4`}>
              <QuestionsFooter />
            </div>
          </div>
        </div>
      </TestIdScope>
    </>
  );
};

export default SignUpEmailAttached;
